//import 'ol/ol.css';
import { FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { MapLayerGroupType, INewGeometryConfig } from '../Shared/Models/MapConfigModels';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import GeometryType from 'ol/geom/GeometryType';
import { TableInLineEdits } from '../Shared/Utility/TableInLineEdits';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2 = '#placeholder-for-legalmodals2',

    legalEventsEditLegalFeaturesAddBtn = '#legalEventsEditLegalFeaturesAddBtn',
    legalEventsEditLegalFeaturesEditBtn = '#legalEventsEditLegalFeaturesEditBtn',
    legalEventsEditLegalFeaturesDeleteBtn = '#legalEventsEditLegalFeaturesDeleteBtn',
    legalEventsEditLegalFeaturesTable = '#legalEventsEditLegalFeaturesTable',
    legalEventsEditModal = '#legalEventsEditModal',
    legalEventsEdit_LegalFeaturesAddModal = '#legalEventsEdit_LegalFeaturesAddModal',
    legalEventsEdit_LegalFeaturesAddSubmitBtn = '#legalEventsEdit_LegalFeaturesAddSubmitBtn',
    legalEventsEdit_LegalFeaturesAddCloseBtn = '#legalEventsEdit_LegalFeaturesAddCloseBtn',
    legalEventsEdit_LegalFeaturesAddCancelBtn = '#legalEventsEdit_LegalFeaturesAddCancelBtn',
    legalEventsEdit_LegalFeaturesAddForm = '#legalEventsEdit_LegalFeaturesAddForm'
}

export class LegalEvents_LegalFeatures {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    private eventNewMapGeometryCompleted;
    private legalRouteInlineEdits: Array<{ LegalFeatureID: String, Label: String }> = [];

    // List of buttions in the action toolbar
    private actionBtns = {
        new: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        delete: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        const self = this;
    }

    public initEvents = (data: ICAMSKey): void => {
        const self = this;

        // Initialize btns
        self.actionBtns = {
            new: {
                btn: $(jqc.legalEventsEditLegalFeaturesAddBtn +' button'), enable: false },
            edit: {
                btn: $(jqc.legalEventsEditLegalFeaturesEditBtn +' button'), enable: false },
            delete: {
                btn: $(jqc.legalEventsEditLegalFeaturesDeleteBtn +' button'), enable: false }
        };

        self.actionBtns.new.btn.on('click', function () { Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);  self.addLegalFeaturesWizard_Start(data); });
        self.actionBtns.edit.btn.on('click', function () { toastr.info('To be completed'); });
        self.actionBtns.delete.btn.on('click', function () { self.deleteLegalFeatures(data); });

        // Inituialize table
        var table: any = Utilities.GetControl(jqc.legalEventsEditLegalFeaturesTable)
        table.bootstrapTable();

        table.on('check.bs.table', function (e, row, $element) {
            self.checkVisibleButtons();
        });
        table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkVisibleButtons();
        });
        table.on('uncheck.bs.table', function (e, row, $element) {
            self.checkVisibleButtons();
        });
        table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkVisibleButtons();
        });
        table.on('click-cell.bs.table', function (e, field, value, row, $element) {
            if (field == "Label") {
                TableInLineEdits.setTableEdit_TextInput(field, value, row, $element).then(r => {
                    if (r.success == true && r.value != value) {
                        // Add the results to an object for submission later on
                        var ent = self.legalRouteInlineEdits.find(f => f.LegalFeatureID == row.LegalFeatureID);
                        if (ent != null) ent.Label = r.value;
                        else self.legalRouteInlineEdits.push({ LegalFeatureID: row.LegalFeatureID, Label: r.value });
                    }
                }).catch();
            }
        });
        table.on('click-cell.bs.table', function (e, field, value, row, $element) {
            if (field == "AnnotationCount") {
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                events.bus.publish(events.eventZoomToWKTandHighlight([[row.WKT], true, true, FeatureType.LegalEvent]));
            }
        });

        // Reset the inline edit object
        self.legalRouteInlineEdits = [];

        // Get Route data
        self.GetLegalFeaturesData(data);
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
   
    public openAddPanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        
        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals2).load('/Legal/LegalEventsEdit_LegalFeaturesAddView', { legalCode: data.code, wkt: data.wkt }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.legalEventsEdit_LegalFeaturesAddModal, ModalAction.Create);

            // Get selected map and record list data
            //$(jqc.legalEventsEdit_LegalFeaturesAddModal + ' [name="singlePathList_Input"]').on('keyup', function () { self.getPathsFromTypeAhead();} );

            Utilities.GetControl(jqc.legalEventsEdit_LegalFeaturesAddSubmitBtn).on('click', function (evt) {
                Utilities.BlockUI($(jqc.legalEventsEdit_LegalFeaturesAddModal + " .modal-content"));
                let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEdit_LegalFeaturesAddForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Legal/AddLegalFeaturesToLegalEvent',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Added Feature!')
                                self.GetLegalFeaturesData(data);
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.LegalFeature));

                                Utilities.GetModal(jqc.legalEventsEdit_LegalFeaturesAddModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                            }
                            else {
                                toastr.error('Failed to add routes!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($(jqc.legalEventsEdit_LegalFeaturesAddModal + " .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.legalEventsEdit_LegalFeaturesAddCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_LegalFeaturesAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
            });

            Utilities.GetControl(jqc.legalEventsEdit_LegalFeaturesAddCancelBtn).on('click', function (evt) {;
                Utilities.GetModal(jqc.legalEventsEdit_LegalFeaturesAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
            });
        });
    }

    public deleteLegalFeatures = (data: ICAMSKey): void => {
        const self = this;

        var table: any = Utilities.GetControl(jqc.legalEventsEditLegalFeaturesTable)
        let rows: Array<any> = table.bootstrapTable('getSelections');
        let legalFeatureIDs = [];
        rows.forEach(r => {
            legalFeatureIDs.push(r.LegalFeatureID);
        });

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                deleteNow();
            }
            else {
            }
        }).catch(e => { });

        function deleteNow() {
            Utilities.BlockUI();
            $.post('/Legal/DeleteLegalFeatures', { legalFeatureIDs: legalFeatureIDs },
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            self.GetLegalFeaturesData(data);
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.LegalFeature));
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                    finally {
                        Utilities.UnBlockUI();
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetLegalFeaturesData = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Legal/GetLegalFeatures";
        let query = { legalCode: data.code };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.legalEventsEditLegalFeaturesTable)
                        table.bootstrapTable('load', data)

                        self.checkVisibleButtons();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    public UpdateLegalFeatureInLineData = (): void => {
        const self = this;

        // Only update if there have been inline edits
        if (self.legalRouteInlineEdits.length == 0) return;

        let url = "/Legal/UpdateLegalFeatures";
        let query = { data: self.legalRouteInlineEdits };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success != true) {
                        toastr.info('Failed to update legal feature data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    public GetLegalCodeFromLegalFeatureID = (legalFeatureID: string): Promise<string> => {
        const self = this;

        return new Promise<string>((resolve, reject) => {

            let url = "/Legal/GetLegalCodeFromLegalFeatureID";
            let query = { legalFeatureID: legalFeatureID };

            $.post(url, query,
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            resolve(result.data);
                        }
                        else {
                            reject();
                        }
                    }
                    catch (err) {
                        console.log(err);
                        reject();
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
                reject();
            });
        });
    }

    // ----------------------------------------------------------- //
    // Add new affected path WIZARD
    public addLegalFeaturesWizard_Start = (data: ICAMSKey): void => {
        const self = this;

        // Make sure the various layers are turned on
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.LegalFeature, true]));

        // Capture the end process
        self.eventNewMapGeometryCompleted = events.bus.subscribe(events.eventNewMapGeometryCompleted, e => {
            self.eventNewMapGeometryCompleted();
            if (e.payload[0] == true) {
                events.bus.publish(events.eventResetAllPanels());
                self.openAddPanel(e.payload[1]);
            }
        });
       
        // Start the process
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false };
        let config: INewGeometryConfig = { data: data, featureType: FeatureType.LegalFeature, skipStep2withGeom: GeometryType.LINE_STRING, interactionData: interactionData };
        events.bus.publish(events.eventNewMapGeometryStart([config, localCallback]));

        function localCallback(r) {

        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private checkVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.legalEventsEditLegalFeaturesTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionBtns.new.enable = true;
        if (rows && rows.length == 1) {
            self.actionBtns.edit.enable = true;
            self.actionBtns.delete.enable = true;
        }
        else if (rows && rows.length > 1) {
            self.actionBtns.delete.enable = true;
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }
}




